<!-- TelaExtraiDadosUsuario.svelte -->
<script>
  import ExtraiDadosBasico from "../../Componentes/ExtracaoDados/ExtraiDadosBasico.svelte";
  import ExibeItem from "../../Classes/exibeItem.js";
  import BotaoInserir from "../../componentes_basicos/BotaoInserir.svelte";
  import Pesquisa from "../../Componentes/ExtracaoDados/Pesquisa.svelte";
  import { DadosLogin } from "../../Classes/Stores";
  import Constantes from "../../Classes/Constantes";
  import TelasAcessoNaoAutorizado from "./TelasAcessoNaoAutorizado.svelte";

  let id_assessoria = $DadosLogin.id_assessoria;
  // Define as propriedades para o componente ExtraiDadosBasico
  let termo_pesquisa = "";
  let extraiDadosBasico;
  const api = "consultas.php";
  const parametros = {
    query_code: "consulta_treinos_corrida",
    termo_pesquisa: termo_pesquisa,
    campos_pesquisaveis: ["Treino"],
    id_assessoria: id_assessoria,
  };
  const celulas = [new ExibeItem("Nome", "Treino")];

  //só precisa configurar acima disto
</script>

<div class="centralizar">
  {#if id_assessoria > 0}
  <br>
  <br>
  <br>

    <Pesquisa {parametros} bind:value={termo_pesquisa} {extraiDadosBasico}
      ><ExtraiDadosBasico
        {api}
        {parametros}
        {celulas}
        bind:this={extraiDadosBasico}
        navegacao={Constantes.tela_monta_intervalo}
      />
    </Pesquisa>

    <BotaoInserir navegarPara={Constantes.tela_monta_intervalo} />
  {:else}
    <TelasAcessoNaoAutorizado />
  {/if}
</div>

<style>
  .centralizar {
    margin-top: 20px;
    margin-bottom: 100px;
    background-image: url("/img/pista3.jpg");
    background-size: cover; /* Para cobrir toda a tela */
    background-position: center; /* Para centralizar a imagem */
  }
</style>
